module.exports = __webpack_public_path__ + "img/btn_link_6.5c61e821.png";